// extracted by css-extract-rspack-plugin
export default {"logo":"ProfileForm_logo__ye3vp","imageContainer":"ProfileForm_imageContainer__PfnIn","editDetailsBtnContainer":"ProfileForm_editDetailsBtnContainer__f57Ou"};